import { Location } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { UserOverviewBaseComponent } from '../user-overview-base.component';
import { ClubAssignmentComponent } from '../../club-assignment/club-assignment.component';
import { LocalModalComponent } from '~shared/components/elements/local-modal/local-modal.component';
import {
  ClubService,
  DefaultNotificationService,
  NavigationService,
  StorageService,
  UserManagementService,
  UserService,
} from '~core/services';
import { ClubListTranslationsService, CustomerStatusTranslationsService } from '~shared/translations';

import { FormLabelTranslationService } from '~shared/components/form-fields/translations/form-label-translations.service';
import { TooltipTranslationService } from '~shared/translations';

/**
 * Component responsible for user administration.
 */
@UntilDestroy()
@Component({
  selector: 'app-user-overview',
  templateUrl: './user-overview.component.html',
  styleUrls: ['../user-overview-base.component.scss'],
  // styleUrls: ['./user-overview.component.scss', '../../../crm/customer-overview/customer-overview.component.scss']
})
export class UserOverviewComponent extends UserOverviewBaseComponent implements OnInit, OnDestroy {
  @ViewChild(LocalModalComponent) resultsDataTable: LocalModalComponent;
  @ViewChild(ClubAssignmentComponent) clubAssignment: ClubAssignmentComponent;

  public i18nModalTitle: string;
  constructor(
    public notificationService: DefaultNotificationService,
    public navigationService: NavigationService,
    public userService: UserService,
    public userModalService: UserManagementService,
    public router: Router,
    public clubService: ClubService,
    public clubListTranslations: ClubListTranslationsService,
    public location: Location,
    public formBuilder: UntypedFormBuilder,
    public storage: StorageService,
    public route: ActivatedRoute,
    public customerStatusTranslations: CustomerStatusTranslationsService,
    public flTranslations: FormLabelTranslationService,
    public tooltipTranslations: TooltipTranslationService,
    @Inject(LOCALE_ID) public locale: string
  ) {
    super(notificationService, navigationService, userService, userModalService, router, clubService, clubListTranslations, location,
      formBuilder, storage, route, customerStatusTranslations, locale);

    this.i18nModalTitle = $localize`:@@userProfile.modalTitle.clubAssignment:Club assignment`;
  }
}
